import api from '../utils/api';

// Category interface (matches backend Category model)
export interface ICategory {
  _id: string;
  categoryTag: string;
  name: string;
  stateID: number;
  professionID: string;
  stateRequirementID?: string;
  minCredits?: number;
  maxCredits?: number;
  description?: string;
}

export interface IStateRequirement {
  _id?: string;
  professionID: string;
  stateID: number;
  effectiveDate: string;
  expiryDate?: string;
  totalCreditsRequired: number;
  cycleLengthYears: number;
  categoryIDs: ICategory[]; // Populated Category documents (array of ObjectIds populated by backend)
  // Fixed cycle dates
  hasFixedCycleDates?: boolean;
  fixedCycleStartMonth?: number;
  fixedCycleStartDay?: number;
  fixedCycleEndMonth?: number;
  fixedCycleEndDay?: number;
  cycleDateNotes?: string;
  // Birthday-anchored cycles (e.g. WA ARCH) — distinct from hasFixedCycleDates.
  isBirthdayAnchored?: boolean;
  // Optional rules
  allowCarryover?: boolean;
  carryoverMaxCredits?: number;
  lectureMinCredits?: number;    // Min hours of live/lecture instruction
  selfStudyMaxPercent?: number;  // Deprecated
  lectureMinPercent?: number;    // Deprecated
  notes?: string;
  // Reference links
  stateprofessionlink1?: string;
  stateprofessionlink1desc?: string;
  stateprofessionlink2?: string;
  stateprofessionlink2desc?: string;
  createdAt?: string;
  updatedAt?: string;
  professionName?: string;
  stateName?: string;
  stateAbbreviation?: string;
  creditTerminology?: string;
}

export const getAllStateRequirements = async (): Promise<IStateRequirement[]> => {
  const res = await api.get('/api/state-requirements');
  return res.data;
};

export const getStateRequirement = async (professionID: string, stateID: number): Promise<IStateRequirement> => {
  const res = await api.get(`/api/state-requirements/${professionID}/${stateID}`);
  return res.data;
};

export const getStateRequirementsForProfession = async (professionID: string): Promise<IStateRequirement[]> => {
  const res = await api.get(`/api/state-requirements/profession/${professionID}`);
  return res.data;
};

export const getStateRequirementsForState = async (stateID: number): Promise<IStateRequirement[]> => {
  const res = await api.get(`/api/state-requirements/state/${stateID}`);
  return res.data;
};

// Add, update, delete as needed for admin
export const createStateRequirement = async (data: Partial<IStateRequirement>): Promise<IStateRequirement> => {
  const res = await api.post('/api/state-requirements', data);
  return res.data;
};

export const updateStateRequirement = async (id: string, data: Partial<IStateRequirement>): Promise<IStateRequirement> => {
  const res = await api.put(`/api/state-requirements/${id}`, data);
  return res.data;
};

export const deleteStateRequirement = async (id: string): Promise<void> => {
  await api.delete(`/api/state-requirements/${id}`);
};
